(function () {
  function syncQuantity(form) {
    // Cherche le composant quantité dans la page (pas forcément dans le form)
    const qtyComponent = document.querySelector('quantity-selector-component');
    if (!qtyComponent) return;

    const qtyInput = qtyComponent.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const qty = parseInt(qtyInput.value, 10);
    if (isNaN(qty) || qty < 1) return;

    // Cherche ou crée l'input caché dans le form
    let hidden = form.querySelector('input[name="quantity"][data-synced]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'quantity';
      hidden.setAttribute('data-synced', 'true');
      form.appendChild(hidden);
    }
    hidden.value = qty;
  }

  function attachListeners() {
    // Cible le form natif Shopify (product-form ou form[action="/cart/add"])
    const forms = document.querySelectorAll(
      'product-form form, form[action="/cart/add"]'
    );

    forms.forEach((form) => {
      // Retire l'ancien listener si déjà attaché
      form.removeEventListener('submit', form._qtySyncHandler);
      form._qtySyncHandler = (e) => syncQuantity(form);
      form.addEventListener('submit', form._qtySyncHandler);
    });
  }

  // Attendre que le DOM soit prêt + re-attacher si Shopify recharge la section
  document.addEventListener('DOMContentLoaded', attachListeners);
  document.addEventListener('shopify:section:load', attachListeners);
})();
